import { gql, useLazyQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseLazyQuery } from '@/lib/apollo/types'

const getLandlordRefereeQuery = gql`
  query ($customerId: String!, $subjectId: String!) {
    getLandlordReferee(customerId: $customerId, subjectId: $subjectId) {
      id
      applicationId
      customerId
    }
  }
`

export type QueryVars = {
  customerId: string
  subjectId: string
}

export type LandlordReferee = {
  id: string
  applicationId: string
  customerId: string
}

export type GetLandlordRefereeData = {
  getLandlordReferee: LandlordReferee
}

export const useGetLandlordRefereeQuery: WrappedUseLazyQuery<
  GetLandlordRefereeData,
  QueryVars
> = options =>
  useLazyQuery<GetLandlordRefereeData, QueryVars>(getLandlordRefereeQuery, {
    ...options,
    client: agentClient,
  })
